(function() {
	'use strict';

	angular.module('quantixApp').controller('SMSOTPVerification',
			SMSOTPVerification)

        .filter('dateFilter', function() {

		return function(s) {
			var ms = s % 1000;
			s = (s - ms) / 1000;
			var secs = s % 60;
			if (('' + secs).length == '1') {
				secs = '0' + secs
			}
			s = (s - secs) / 60;
			var mins = s % 60;

			return '0' + mins + ':' + secs;
		};
	});

	SMSOTPVerification.$inject = [ '$translate', '$timeout', 'Auth','$stateParams','OTPService','$scope','$state'];

	function SMSOTPVerification($translate, $timeout, Auth, $stateParams,OTPService,$scope,$state) {
		var vm = this;
		vm.verifyotp=verifyotp;
		vm.smsOtp = null;
		vm.otperror = false;
		vm.valid = false;
		vm.timer = true;
		vm.verbut=false;
		vm.register = register;
		vm.resendOtp = resendOtp;
		vm.distimer=distimer;
		vm.oopsmes=false;
		vm.smsOtp=null;
		vm.smsotpdto={};
		vm.internal=false;
		vm.registerAccount={};
        $scope.invalidotp=false;
        vm.failure=false;
        vm.otperror=false;
		var otpErrors = {
				"invalid_otp": "Your OTP is invalid",
				"mobile_not_found": "Mobile number not found",
				"invalid_auth_key": "OTP Authentication key is invalid",
				"otp_not_verified": "Your OTP has not been verified"
		};
		
        var loadAllData=function(){
        	 vm.timer = false;
	       if($stateParams.registereddata!=null){
	    	   vm.registerAccount=$stateParams.registereddata;
	    	   vm.smsotpdto.mobileNumber=vm.registerAccount.mobileNumber;
				  OTPService.sendotpservice(vm.smsotpdto).then(function(result){
					if(result.type === 'success'){
		    			
		    			 distimer();
		    			 //vm.smsotpdto.oneTimePassword=data.response.oneTimepassword;
		    		}else{
		    			vm.internal=true;
		    			vm.oopsmes=true;
		    		}   
				  
				  })["catch"](function (response) {
		                vm.success = null;
		                vm.internal=true;
		                vm.oopsmes=true;
		            }); 
	       }else{
	    	   $state.go('register');
	       }
        }
	       function register(){
	        	//vm.success = 'OK';
	        	Auth.createAccount($stateParams.registereddata).then(function () {
	        		vm.oopsmes=false;
	        		vm.success = 'OK';
	            })["catch"](function (response) {
	                vm.success = null;
	                vm.internal=true;
	                vm.oopsmes=true;
	                vm.failure=true;

	            });
	        }
	       function verifyotp(){
	    	   
	    	   if(!vm.timer){
	    	   vm.smsotpdto.oneTimePassword=Auth.encryptPassword(vm.smsOtp);
	    	   OTPService.verifyotpservice(vm.smsotpdto).then(function(result){
	    		   if(result.type === 'success'){
	    			   $scope.invalidotp=false;
	    			   vm.valid=true;
	    			   vm.otperror = false;
	    		   } else if(result.type==='error') {
	    			   vm.message = otpErrors[result.message];
	    			   vm.otperror = true;
	    		   } else{
	    			   vm.oopsmes=true;
	    		   }
	    		   
	    	   })["catch"](function (response) {
	                vm.success = null;
	                vm.internal=true;
	                vm.oopsmes=true;
	            });
	    	   
	    	   }
	        }
	   

	       function distimer() {
	    	   vm.timer = false;
	    	   vm.verbut=false;
	    	   vm.time = 120000;
	    	   $timeout(function() {
	    	   vm.timer = true
	    	   vm.verbut=true;
	    	   }, 120000);
	    	   var timer = function() {
	    	   if (vm.time > 0) {
	    	   vm.time -= 1000
	    	   $timeout(timer, 1000);
	    	   }
	    	   }
	    	   $timeout(timer, 1000);
	    	   }
	       function resendOtp(){
	    	   $scope.invalidotp=false;
	    	   loadAllData();
	       }

		loadAllData();
	}
	  
})();
